import useEmblaCarousel from "embla-carousel-react";
import { useEffect, useState } from "react";
import { comments } from "./data";

const UserComments = () => {
  const [current, setCurrent] = useState(0);
  const [emblaRef, embla] = useEmblaCarousel({
    dragFree: true,
    containScroll: "trimSnaps",
    align: "center",
    direction: "rtl",
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const next = (current + 1) % comments.length;
      setCurrent(next);
      embla?.scrollTo(next);
    }, 4000);

    return () => clearInterval(interval);
  }, [current, embla]);

  const activeComment = comments[current];

  return (
    <div className="p-5">
      <div className="flex flex-col-reverse items-center justify-center gap-10 md:gap-24 lg:flex-row">
        <div className="md:w-[456px] flex flex-col items-center md:items-start gap-2.5 md:gap-6 transition-all duration-500">
          <h3 className="text-[40px] font-kalameh">نظرات هنرجویان</h3>
          <p className="text-[32px] font-kalameh">{activeComment.name}</p>
          <div className="flex flex-col gap-2.5 md:gap-5 mt-4 md:mt-0">
            {activeComment.text.map((t, i) => (
              <p
                key={i}
                className="font-kalameh font-light text-2xl text-[#333333]"
              >
                {t}
              </p>
            ))}
          </div>
        </div>

        <div className="relative transition-all duration-500">
          <img
            src={activeComment.avatar}
            alt={activeComment.name}
            width={373}
            height={373}
            className="w-[154px] md:h-[373px] h-[154px] md:w-[373px]"
          />
          <div className="w-[50px] h-[50px] md:w-[122px] md:h-[122px] bg-white flex items-center justify-center shadow-lg rounded-full absolute bottom-0 left-0">
            <img
              src="/images/microphone.png"
              alt="microphone"
              width={55}
              height={55}
              className="w-[22px] md:h-[55px] h-[22px] md:w-[55px]"
            />
          </div>
        </div>
      </div>

      <div className="relative flex flex-col items-center justify-center mt-10 md:mt-28">
        <img src="/images/isolation_mode.png" alt="isolation_mode" />
        <div
          className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2 w-full md:max-w-[80%] lg:max-w-[60%] overflow-hidden"
          ref={emblaRef}
        >
          <div className="flex gap-2.5 md:gap-5">
            {comments.map((item, index) => (
              <img
                key={item.id}
                src={item.avatar}
                alt={item.name}
                className={`w-[36px] h-[36px] md:w-[62px] md:h-[62px] rounded-full object-cover cursor-pointer transition-all duration-300 ${
                  index === current
                    ? "border-2 border-[#54C6F9] scale-90 shadow-md"
                    : "opacity-80 hover:opacity-100"
                }`}
                onClick={() => setCurrent(index)}
              />
            ))}
          </div>
        </div>

        <p className="font-kalameh mt-5 text-sm md:text-[20px] text-[#333333] transition-all duration-500 text-center">
          {activeComment.name}
        </p>
      </div>
    </div>
  );
};

export default UserComments;
